import { render, staticRenderFns } from "./ClearanceMalaria.vue?vue&type=template&id=5d399c26&"
import script from "./ClearanceMalaria.vue?vue&type=script&lang=js&"
export * from "./ClearanceMalaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports